/*
 * General custom scripts
 */

/**
 * Header
 */
import { menu } from './front/menu';
import { osanoLinks } from './front/privacy-choices';
import { amplitudeButtonEvents } from './front/amplitude-button-events';
import './front/demo-calendar-routing-bootstrap';

// Initialize components
document.addEventListener( 'DOMContentLoaded', () => {

	menu();
	osanoLinks();
	amplitudeButtonEvents();

} );
